import _ from 'lodash';

export default function redactAttachment(attachments, id) {
  const attachment = _.find(attachments, { id });
  attachment && attachment.redact();
}



// WEBPACK FOOTER //
// ./src/scripts/domain/models/attachment_redact.js